
import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useInternalAuth } from '@/hooks/useInternalAuth';
import { hasPermission, Permission } from '@/utils/rbac';
import { UserRole, AgeGroup } from '@/types/user';

interface PermissionGateProps {
  permission: Permission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  role?: UserRole;
  ageGroup?: AgeGroup;
}

const PermissionGate: React.FC<PermissionGateProps> = ({ 
  permission, 
  children, 
  fallback = null,
  role: overrideRole,
  ageGroup: overrideAgeGroup
}) => {
  const { profile } = useAuth();
  const { user: internalUser } = useInternalAuth();

  // Determine user role and age group
  const userRole = overrideRole || 
                   (profile?.role as UserRole) || 
                   (internalUser?.role as UserRole) || 
                   'player';
  
  const userAgeGroup = overrideAgeGroup || 
                       (profile?.age_group as AgeGroup) || 
                       (internalUser?.age_group as AgeGroup) || 
                       '18-plus';

  // Check if user has the required permission
  const hasRequiredPermission = hasPermission(userRole, userAgeGroup, permission);

  if (!hasRequiredPermission) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGate;
